import "./cart-dropdown.styles.scss"
import { useContext } from "react"
import { CartContext } from "../../contexts/cart.context"
import CartItem from "../cart-item/cart-item.component"

import Button from "../button/button.component"
import { useNavigate } from "react-router-dom"

const CartDropdown = () =>{

    const {cartItems} = useContext(CartContext);
    const navigate = useNavigate();

    const goToCheckoutHandler = ()=>{
        navigate("/checkout")
    }

    return(
        <div className="cart-dropdown-container" data-testid="cart-dropdown"> 
            <div className="cart-items">
                {cartItems.map((item) =>(
                     <CartItem key={item.id} cartItem = {item} />                   
                ))}
            </div>
            <Button buttonType="inverted" onClick = {goToCheckoutHandler}>GO TO CHECKOUT</Button>

        </div>

    )
}

export default CartDropdown;